(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var SECTION = 'main-collection';

    function init() {
      var sentinel = document.getElementById('collection-infinite-sentinel');
      if (!sentinel || sentinel.dataset.hasMore !== 'true') return;

      var loading = false;

      function plpThumbDedupeKey(a) {
        if (!a || !a.querySelector) return '';
        var pl = a.querySelector('.pl-collection[data-label-product-handle]');
        if (pl) {
          var h = pl.getAttribute('data-label-product-handle');
          if (h) return h;
        }
        var href = a.getAttribute('href');
        if (!href) return '';
        try {
          return new URL(href, window.location.href).pathname;
        } catch (e) {
          return href.split('?')[0];
        }
      }

      // Mirrors the observer's 400px rootMargin — "is the sentinel close
      // enough that we should still be pulling pages?"
      function sentinelInRange() {
        var r = sentinel.getBoundingClientRect();
        return r.top < window.innerHeight + 400 && r.bottom > -400;
      }

      // ── Scroll memory ─────────────────────────────────────────────────
      // Infinite scroll and the back button disagree. Going back re-renders
      // page 1 ONLY, so a document that was six pages tall is suddenly one
      // page tall and the saved scroll offset no longer exists on it. The
      // browser clamps near the top, then re-tries as content streams in —
      // the reported "goes to the top, then drops down, not always exactly
      // where I was".
      //
      // The offset alone is therefore useless; what has to be restored is the
      // GRID. So remember how many pages the visitor had built and where they
      // were, and on a back/forward navigation rebuild that much before
      // putting them back.
      //
      // bfcache needs no handling here: when it applies, the document is
      // resumed wholesale — DOM, scroll and all — and none of this re-runs.
      // Which is also why the save listener is 'pagehide' and NOT 'unload' /
      // 'beforeunload': those two make a page bfcache-ineligible, and would
      // trade a broken back button for a needlessly slow one.
      var STORE_KEY = 'slj-plp-scroll:' + location.pathname + location.search;
      var pagesLoaded = 1; // page 1 is server-rendered
      var restoreTo = null;

      window.addEventListener('pagehide', function () {
        try {
          sessionStorage.setItem(
            STORE_KEY,
            JSON.stringify({
              y: window.scrollY || window.pageYOffset || 0,
              pages: pagesLoaded,
            })
          );
        } catch (e) {
          // Private-mode / quota — scroll memory is a nicety, never a blocker.
        }
      });

      function savedState() {
        var nav =
          performance.getEntriesByType &&
          performance.getEntriesByType('navigation')[0];
        var isBackForward = nav
          ? nav.type === 'back_forward'
          : performance.navigation && performance.navigation.type === 2;
        if (!isBackForward) return null; // a fresh visit starts at the top
        try {
          return JSON.parse(sessionStorage.getItem(STORE_KEY));
        } catch (e) {
          return null;
        }
      }

      function appendNext() {
        if (loading) return;
        var nextPage = sentinel.getAttribute('data-next-page');
        if (!nextPage || sentinel.getAttribute('data-has-more') !== 'true') return;

        loading = true;
        var reqUrl = new URL(window.location.href);
        reqUrl.searchParams.set('sections', SECTION);
        reqUrl.searchParams.set('page', nextPage);

        fetch(reqUrl.toString())
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var html = data && data[SECTION];
            if (!html) return;

            var wrap = document.createElement('div');
            wrap.innerHTML = html;

            var srcScroll = wrap.querySelector('#shop-scroll');
            var sentinelEl = document.getElementById('collection-infinite-sentinel');
            var shopScroll = document.getElementById('shop-scroll');
            if (srcScroll && sentinelEl && shopScroll) {
              var seenKeys = new Set();
              var existing = shopScroll.querySelectorAll('a.shop-thumb');
              for (var ei = 0; ei < existing.length; ei++) {
                var k0 = plpThumbDedupeKey(existing[ei]);
                if (k0) seenKeys.add(k0);
              }
              var buf = [];
              var ch = srcScroll.children;
              for (var i = 0; i < ch.length; i++) {
                var el = ch[i];
                if (!el.classList) continue;
                // Editorial tiles append as-is, in DOM order (one per
                // page, unique — no dedup needed). Keeping them inline
                // between products preserves their grid placement.
                if (el.classList.contains('editorial-image')) {
                  buf.push(el.outerHTML);
                  continue;
                }
                if (!el.classList.contains('shop-thumb')) continue;
                var k = plpThumbDedupeKey(el);
                if (k && seenKeys.has(k)) continue;
                if (k) seenKeys.add(k);
                buf.push(el.outerHTML);
              }
              if (buf.length) {
                sentinelEl.insertAdjacentHTML('beforebegin', buf.join(''));
              }
            }

            var nextSentinel = wrap.querySelector('#collection-infinite-sentinel');
            if (nextSentinel) {
              sentinel.setAttribute('data-has-more', nextSentinel.getAttribute('data-has-more') || 'false');
              var np = nextSentinel.getAttribute('data-next-page');
              if (np) {
                sentinel.setAttribute('data-next-page', np);
              } else {
                sentinel.removeAttribute('data-next-page');
              }
            }

            if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
              window.lazyLoadInstance.update();
            }
          })
          .catch(function () {})
          .finally(function () {
            loading = false;

            // IntersectionObserver only fires on a CHANGE of intersection.
            // One page of 12 cards frequently isn't tall enough to push the
            // sentinel back out of the 400px root margin — most acutely in
            // the dense S view (6-up), where 12 cards add only ~2 short rows.
            // The sentinel stays intersecting, so no new entry is ever
            // delivered and loading stalls: the client's "it only loads a
            // couple of rows and I have to scroll up and back down to have
            // the rest load in". Scrolling UP is what forces the state change
            // the observer needs.
            //
            // So re-check by hand and keep pulling until the sentinel is
            // genuinely out of range (or the pages run out). This also
            // recovers triggers dropped by the `loading` guard above.
            //
            // Guard: only continue if the response actually advanced the
            // cursor. A malformed/failed response leaves data-next-page as it
            // was, and without this we'd refetch the same page forever.
            var advanced = sentinel.getAttribute('data-next-page') !== nextPage;
            if (advanced) pagesLoaded++;

            // Rebuilding a remembered grid: keep pulling until we've restored
            // as many pages as the visitor had, THEN put them back. Driven
            // from here rather than by sentinelInRange(), because during a
            // restore we're still parked at the top of the page — the sentinel
            // leaves range almost immediately and the normal chain would stop
            // several pages short of where they actually were.
            if (restoreTo) {
              var more = sentinel.getAttribute('data-has-more') === 'true';
              if (advanced && more && pagesLoaded < restoreTo.pages) {
                appendNext();
                return;
              }
              // Reached the saved depth — or ran out of pages / hit an error,
              // in which case land as close as the grid allows rather than
              // stranding them at the top.
              var y = restoreTo.y;
              restoreTo = null;
              window.scrollTo(0, y);
              return;
            }

            if (advanced && sentinelInRange()) appendNext();
          });
      }

      if (!('IntersectionObserver' in window)) {
        var onScroll = function () {
          var rect = sentinel.getBoundingClientRect();
          if (rect.top < window.innerHeight + 400) appendNext();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) appendNext();
          }
        },
        { rootMargin: '400px 0px', threshold: 0 }
      );
      io.observe(sentinel);

      // Came back to this grid — put it back the way they left it.
      // scrollRestoration goes 'manual' ONLY when there's something to
      // restore, so ordinary loads keep the browser's native behavior and a
      // visitor is never stranded at the top by this code path.
      var saved = savedState();
      if (saved && saved.y > 0) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        if (saved.pages > 1 && sentinel.getAttribute('data-has-more') === 'true') {
          restoreTo = saved;
          appendNext(); // chains in .finally until the grid is deep enough
        } else {
          // Only page 1 to rebuild: the grid is already whole, just go there.
          window.scrollTo(0, saved.y);
        }
      }

      // The S/M/L toggle changes grid density, which moves the sentinel — and
      // switching to S is the worst case, since the same 12 cards collapse
      // from 6 tall rows into 2 short ones and the grid can end up far short
      // of the fold. The observer is no help when the sentinel was ALREADY
      // intersecting: its state doesn't change, so no entry is delivered.
      // Re-check explicitly on every size flip; appendNext() then chains
      // until the grid reaches past the fold again.
      if (window.MutationObserver) {
        var sizeToken = function () {
          var m = document.documentElement.className.match(/plp-size-\w/);
          return m ? m[0] : '';
        };
        var lastSize = sizeToken();
        new MutationObserver(function () {
          var now = sizeToken();
          if (now === lastSize) return;
          lastSize = now;
          if (sentinelInRange()) appendNext();
        }).observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop"]) return;
  try {
    
  if (window.localStorage) {
    window.localStorage.last_shop_visited = window.location.pathname;
  }

  } catch(e) { console.error(e); }
})();
})();
